import React, {useState} from 'react';
import {Grid} from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import DeleteIcon from "@mui/icons-material/Delete";
import {useImageBrowser} from "../../../hoc/useImageBrowser";
import {deleteCustomerApi, updateCustomerApi} from "../../../api/AdminApi";
import {BLOCK_FETCHING} from "../../../redux/action/type.action";
import {SetState} from "../../../redux/reduxhelper";
import {useDispatch} from "react-redux";
import ModalDeleteCustomer from "../../../pages/Admin/dashboard/customers/modal/ModalDeleteCustomer";


const GalleryCustomer = ({item = null, invalidateData},) => {
    const [clickModal, setClickModal] = useState(null);

    const dispatch = useDispatch()
    const uploadFileCallback = async (file) => {
        dispatch(SetState(BLOCK_FETCHING, true))
        try {

            await updateCustomerApi({customer_id: item?.id, image: file, name: item?.id})
            if (invalidateData) invalidateData();
        } catch (e) {
            // log error
        }
        dispatch(SetState(BLOCK_FETCHING, false))
    }

    const [imageBrowser] = useImageBrowser(async (result) => {
        await uploadFileCallback({...result}.blobFile);
    }, false)

    const deleteCustomerItem = async () => {
        try {
            await deleteCustomerApi({customer_id: item?.id})
            if (invalidateData) invalidateData();
        } catch (e) {
            // log error

        }
    }

    // console.log('iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii', item)
    return (
        <Grid item xs={12} md={6} padding={1} maxHeight={'150px'} mb={1}>
            <Grid
                sx={{
                    background: "#592EA92E",
                    border: "1px solid #5222ac",
                    position: 'relative',
                    height: '150px'
                }}>
                <img
                    src={item?.image_url}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }} alt={''}/>
                <Grid sx={{
                    position: 'absolute',
                    display: "flex",
                    gap: 1,
                    justifyContent: "flex-end",
                    right: 0,
                    bottom: 0,
                    mr: 1
                }}>
                    <AddPhotoAlternateIcon sx={{mr: 1, color: "#592EA9", cursor: "pointer"}}
                                           onClick={() => imageBrowser.browseForFile()}/>

                    <DeleteIcon onClick={() => setClickModal(item)} sx={{color: "#592EA9", cursor: "pointer"}}/>

                    {imageBrowser?.components}
                </Grid>

            </Grid>
            {clickModal !== null &&
                <ModalDeleteCustomer open={true} close={() => setClickModal(null)} customItem={deleteCustomerItem}
                                     invalidateData={invalidateData}/>
            }

        </Grid>
    );
};

export default GalleryCustomer;